import { Card, Menu } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import {getSpaceUrl} from 'utils/api'
import { useTranslation } from 'react-i18next'
import './index.scss'

const mockX = (roomX=10) => {
  let X = [];
  let i = 0;
  while (i < roomX) {
    // X.push(i.toFixed(1));
    X.push(i.toFixed(1));
    // i += 0.01;
    i += 0.1;
  }
  return X
}

const mockY = (roomY=10) => {
  let Y = [];
  let j = 0;
  while (j < roomY) {
    // Y.push(j.toFixed(1));
    Y.push(j.toFixed(1));
    // j += 0.01;
    j += 0.1;
  }
  return Y
}

const RealtimeLocation = (props) => {

  const { t } = useTranslation();
  const [option, setOption] = useState({})

  const chartRef = useRef(null);

  const baseOption = {
    tooltip: {
      show: true,
      trigger: "item",
      formatter: function (params) {
        if (!params.value) return "";

        if (params.value.length > 1) {
          return (
            params.seriesName +
            " :<br/>" +
            params.value[0] +
            "m " +
            params.value[1] +
            "m "
          );
        }
        return (
          params.seriesName +
          " :<br/>" +
          params.name +
          " : " +
          params.value +
          "m "
        );
      }
    },
    grid: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    xAxis: {
      type: "value",
      axisLine: { show: false },
      axisLabel: { formatter: "{value} m" },
      splitLine: {
        show: true,
        lineStyle: { type: "dashed" }
      }
    },
    yAxis: {
      type: "value",
      axisLine: { show: false },
      axisLabel: { formatter: "{value} m" },
      splitLine: {
        show: true,
        lineStyle: { type: "dashed" }
      }
    },
    animation: false,
    series: []
  };

  // -----------------------------
  // INIT (RUN ONCE ONLY)
  // -----------------------------
  useEffect(() => {
    const chart = chartRef.current.getEchartsInstance();
    chart.setOption(baseOption);
  }, []);

  useEffect(() => {
    console.log("persons: ", props.persons);
    const chartInstance = chartRef.current?.getEchartsInstance();
    if (!chartInstance || !props.room) return;

    const setGraphicImageSize = () => {
      const chartWidth = chartInstance.getWidth();
      const chartHeight = chartInstance.getHeight();

      const imageUrl = getSpaceUrl() + props.room.IMAGE_NAME;

      const option = {
        graphic: [
          {
            id: "bg",
            type: "image",
            style: {
              image: imageUrl,
              x: 0,
              y: 0,
              width: chartWidth,
              height: chartHeight
            }
          }
        ],

        // 🔥 IMPORTANT: LOCK AXIS (NO AUTO-SCALING)
        xAxis: {
          min: 0,
          max: props.room.ROOM_X,
          scale: false
        },

        yAxis: {
          min: 0,
          max: props.room.ROOM_Y,
          scale: false
        },

        series: [
          ...props.sensors,
          ...props.persons,
          ...props.exits
        ]
      };

      chartInstance.setOption(option, {
        replaceMerge: ["series", "graphic"]
      });
    };

    setGraphicImageSize();

    window.addEventListener("resize", setGraphicImageSize);

    return () => {
      window.removeEventListener("resize", setGraphicImageSize);
    };
  }, [props.room, props.sensors, props.persons, props.exits]);

  return (
    <Card 
      title={t("historyPage.realtime_location")}
      style={{ height: "100%"}} 
      className='content-card'
    >
      
      <ReactECharts option={option} ref={chartRef}/>
      {
        props.room_empty?
          <div id="empty-lable" style={{
            position: 'absolute',
            top: '40%',
            left: '40%',
            fontSize: '-webkit-xxx-large',
            color: 'coral',
          }}>{t("posture.empty")}</div>:
          <div className="legend" id="status-label">
            <div className="legend-item">
                <div className="legend-color" style={{backgroundColor: '#080808'}}></div>
                <div className="legend-label">{t("posture.none")}</div>
            </div>
            <div className="legend-item">
                <div className="legend-color" style={{backgroundColor: '#f8fc03'}}></div>
                <div className="legend-label">{t("posture.moving")}</div>
            </div>
            <div className="legend-item">
                <div className="legend-color" style={{backgroundColor: '#0918e3'}}></div>
                <div className="legend-label">{t("posture.upright")}</div>
            </div>
            <div className="legend-item">
                <div className="legend-color" style={{backgroundColor: '#8d61be'}}></div>
                <div className="legend-label">{t("posture.laying")}</div>
            </div>
            <div className="legend-item">
                <div className="legend-color" style={{backgroundColor: '#fc0303'}}></div>
                <div className="legend-label">{t("alert.details.fall")}</div>
            </div>
            <div className="legend-item">
                <div className="legend-color" style={{backgroundColor: '#20fc03'}}></div>
                <div className="legend-label">{t("posture.social")}</div>
            </div>
        </div>
      }
      
    </Card>
  );
};

export default RealtimeLocation;